import { loadItems } from 'state/teamsnap/actions';

const loadRegistrationFormLineItemOptions = params => dispatch =>
  dispatch(loadItems('registrationFormLineItemOptions', params));

const loadRegistrationFormItemOptionsByDivisionId = divisionId => dispatch =>
  dispatch(loadRegistrationFormLineItemOptions({ divisionId }));

export { loadRegistrationFormLineItemOptions, loadRegistrationFormItemOptionsByDivisionId };
